import $ from "jquery";

const newsComponent = {
  variable: {
    tabElement: ".media_tabs__item",
    tabContent: ".tab__pane",
    activeTabClass: "active-tab",
    activeContentClass: "active-content",
    tabContentWrapper: ".media_tab--content",
    tab1content: "#tab1-content",
    tab2content: "#tab2-content",
    tabPaneContentTextDate: ".tab__pane--content_text .date",
    url: window.location.href,
  },

  methods: {
    onTabClickHandler: function () {
      const {
        tabElement,
        tabContent,
        activeTabClass,
        activeContentClass,
        tabContentWrapper,
        tab1content,
        tab2content
      } = newsComponent.variable;

      $(document).on("click", tabElement, function (e) {
        e.preventDefault();
        const $tab = $(this);
        const tabId = $tab.attr("id");

        if (!tabId) {return;}

        // Cache selectors
        const $allTabs = $(tabElement);
        const $allContents = $(tabContent);
        const $tabContentWrapper = $(tabContentWrapper);
        const $tab1content = $(tab1content);
        const $tab2content = $(tab2content);

        // Remove active class from all tabs and contents
        $allTabs.removeClass(activeTabClass);
        $allContents.removeClass(activeContentClass);

        // Add active class to clicked tab
        $tab.addClass(activeTabClass);

        // Show corresponding content
        const $activeContent = $("#" + tabId + "-content");
        if ($activeContent.length) {
          $activeContent.addClass(activeContentClass);
        } else {
          console.error(`Content for tab ID "${tabId}" not found.`);
          return;
        }

        if ($(window).width() < 992) {
          if (tabId === "tab1") {
            $tabContentWrapper.css("transform", "translateX(0%)");
          } else if (tabId === "tab2") {
            $tabContentWrapper.css("transform", "translateX(-50%)");
          }
        } else {
          if (tabId === "tab1") {
            $tab1content.css("left", "0");
            $tab2content.css("left", "60%");
          } else if (tabId === "tab2") {
            $tab1content.css("left", "-10%");
            $tab2content.css("left", "0");
          }
        }
      });
    },

    dateFormat: function (dateStr) {
      try {
        const date = new Date(dateStr);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      } catch (error) {
        console.error("Invalid date format: ", dateStr);
        return dateStr;
      }
    },

    changeDateFormat: function () {
      const { tabPaneContentTextDate } = newsComponent.variable;
      const $dateTextElements = $(tabPaneContentTextDate);

      $dateTextElements.each(function () {
        const dateStr = $(this).text();
        const formattedDate = newsComponent.methods.dateFormat(dateStr);
        if(formattedDate === "Invalid date") {
          return $(this).text("");
        }
        else{
          $(this).text(formattedDate);
        }
      });
    },

    dataLayerObj: function (e) {
      var obj = {
          'articleName' : "",
          'blogCategory' : "",
          'blogPageCategory' : "",
          'buttonText' : e ? e.currentTarget.innerText.replace(/\n/g, '').trim() : "",
          'pageSection' : "News and Press Release",
          'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? newsComponent.variable.url.includes("blog") ? "Blogs" : newsComponent.variable.url.substring(newsComponent.variable.url.indexOf(".com/"), newsComponent.variable.url.lastIndexOf('/')  === ".com") && !newsComponent.variable.url.substring(newsComponent.variable.url.indexOf(".com/"), newsComponent.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
          'planOption' : "",
          'productCategory' : "",
          'productName' : "",
          'question' : "",
          'searchTerm' : "",
          'videoTitle' : "",
          'bannerName' : "",
          'bannerType' : ""
      };
      return obj;
  },

    init: function () {
      this.onTabClickHandler();
      this.changeDateFormat();
    },
  },
};

$(() => {
  if ($(".media").length > 0) {
    newsComponent.methods.init();
  }
});
